import React from "react";
import styled from "@emotion/styled";

export default styled.div`
  background-color: #9a8d73;
  padding: 5px 16px;
  border-radius: 48%;
`;